import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Translate, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { monitoraActions } from '../../../store/monitoraStore';
import SanitizedLink from '../../common/sanitizedLink';
import MonitoraDetail from './monitoraDetail';
import MonitoraSemaphore from './monitoraSemaphore';

import './monitora.scss';

class MonitoraAnnotationRow extends React.Component {
    state = {
        detailLoaded: false,
        detailExpanded: false
    };

    render() {
        const a = this.props.article;
        const perex = a.perex.replace(/^[\.\?!-,\"\']/, "").trim();

        return (
            <>
                <tr className="monitora-detail-row-info" ref={e => this.articleRef = e}>
                    <td style={{ fontWeight: "normal" }}>{a.publishedFormatted}</td>
                    <td onClick={() => this.setState({ detailLoaded: true, detailExpanded: !this.state.detailExpanded })}>
                        <span className="link-internal">{a.title}</span>
                    </td>
                    <td>{a.mediatype}</td>
                    <td><SanitizedLink link={a.url} label={a.source} empty={<span>{a.source}</span>} /></td>
                    <td><div title={a.sentiment}><MonitoraSemaphore sentiment={a.sentiment} width={24} height={24} className="aml-semaphore-centered" /></div></td>
                </tr>
                <tr className="monitora-detail-row-body">
                    <td style={{ fontWeight: "normal" }} colSpan={5}>
                        {!this.state.detailExpanded ? <div className="monitora-detail-perex">
                            <span>{ReactHtmlParser(`... ${perex} ...`)}</span>
                            <span className="link-functional monitora-more-less" onClick={() => this.setState({ detailLoaded: true, detailExpanded: true })}>
                                <Translate id="Report.Common.More" />
                            </span>
                        </div> : <div className="monitora-detail-body" style={{ display: this.state.detailExpanded ? "block" : "none" }}>
                            {this.state.detailLoaded ? <MonitoraDetail articleId={a.article_id} articleToken={a.token} articleTitle={a.title}
                                entityId={this.props.entityId} onLessClicked={() => this.onLessClicked()}
                            /> : null}
                        </div>}
                    </td>
                </tr>
            </>
        )
    }

    onLessClicked = () => {
        this.articleRef.scrollIntoView();
        this.setState({ detailExpanded: false });
    }
}

export default withLocalize(connect(
    state => ({ monitora: state.monitora }),
    dispatch => bindActionCreators(monitoraActions, dispatch)
)(MonitoraAnnotationRow));
